<div class="row">
  <div class="col-xs-12 col-sm-12 col-md-8 p-0 m-0">
    <app-user-header [selectedHeader]="header" [tableCategory]="creditInvoice"></app-user-header>

    <div class="col-xs-12 col-sm-12 col-md-12 Registration-split user-information-view">
      <h3 class="pdp-title">
        {{ "userRegistration.userInformation.pageHeader" | cxTranslate }}
      </h3>

      <div id="location-box">
        <div class="locationIcon">
          <img class="locationicon-align" src="../../assets/icons/{{baseSiteId}}/location.svg" alt="location" />
        </div>
        <div class="locationDetails" *ngIf="accountData">
          <span class="selected-loc">{{accountData?.accountname}} ({{accountData?.accountnumber}})</span>
          <span class="change-loc focus" data-toggle="modal" data-keyboard="true" data-target="#location-sel-popup"
            tabindex="0">
            {{
            "userRegistration.userInformation.locationStripSubMessage"
            | cxTranslate
            }}
          </span>
        </div>
      </div>
      <span class="title-sub-heading">{{
        "userRegistration.userInformation.formTitle" | cxTranslate
        }}</span>

      <form [formGroup]="userInfoForm" id="userInfoForm" (ngSubmit)="submitUserInfo()" autocomplete="off">
        <div class="col-xs-12 col-sm-6 col-md-6 p0">
          <div id="registerAccount">
            <div formGroupName="userInfoDetails">
              <div class="
              col-xs-12 col-sm-12 col-md-12
              p0
              Fields-container
              doubleLineContainer
            ">
                <label for="username" class="Fields-label icon-label">{{
                  "userRegistration.userInformation.username.label" | cxTranslate
                  }}
                </label>
                <ng-template #popContent>{{
                  "userRegistration.userInformation.username.popover_msg_1"
                  | cxTranslate
                  }}
                  <br />{{
                  "userRegistration.userInformation.username.popover_msg_2"
                  | cxTranslate
                  }}
                  <br />{{
                  "userRegistration.userInformation.username.popover_msg_3"
                  | cxTranslate
                  }}
                </ng-template>
                <a placement="top" [ngbPopover]="popContent" class="Fields-label icon-label"
                  popoverClass="usernametooltip-popover"><img src="../../assets/icons/{{baseSiteId}}/faqs-plum.svg"
                    alt="faq_reg" class="faq" /></a>
                <input id="username" name="userName" data-valid="valid_facility"
                  aria-labelledby="userName tooltipFacilityName" type="text" class="Fields-input user"
                  autocomplete="off" formControlName="userName" data-di-id="#userName" maxlength="10"  />

                <span *ngIf="
                isUsernameExists &&
                !userInfoForm.get('userInfoDetails.userName').touched
              " class="errorMessage">
                  {{
                  "userRegistration.userInformation.username.existingUsernameMsg"
                  | cxTranslate
                  }}</span>

                <span *ngIf="
                !!userInfoForm.get('userInfoDetails.userName').value &&
                !userInfoForm.get('userInfoDetails.userName').valid &&
                userInfoForm.get('userInfoDetails.userName').errors
                  ?.sameAsaccountNo &&
                userInfoForm.get('userInfoDetails.userName').touched
              " class="errorMessage">{{
                  "userRegistration.userInformation.username.usernameSameAsAccountNo"
                  | cxTranslate
                  }}</span>

                <span *ngIf="
              !!userInfoForm.get('userInfoDetails.userName').value &&
              !userInfoForm.get('userInfoDetails.userName').valid &&
              !userInfoForm.get('userInfoDetails.userName').errors
                ?.sameAsaccountNo &&
              userInfoForm.get('userInfoDetails.userName').errors
                  ?.userNamePasswordMatch &&
              userInfoForm.get('userInfoDetails.userName').touched
            " class="errorMessage">
                  {{
                  "userRegistration.userInformation.username.inValidUsername"
                  | cxTranslate
                  }}
                </span>

                <span *ngIf="
                !!userInfoForm.get('userInfoDetails.userName').value &&
                !userInfoForm.get('userInfoDetails.userName').valid &&
                !userInfoForm.get('userInfoDetails.userName').errors
                  ?.sameAsaccountNo &&
                !userInfoForm.get('userInfoDetails.userName').errors
                  ?.userNamePasswordMatch &&
                userInfoForm.get('userInfoDetails.userName').touched
              " class="errorMessage">{{
                  "userRegistration.userInformation.username.inValidUsername"
                  | cxTranslate
                  }}</span>
                <span *ngIf="
                userInfoForm.get('userInfoDetails.userName').errors?.required &&
                !userInfoForm.get('userInfoDetails.userName').valid &&
                userInfoForm.get('userInfoDetails.userName').touched
              " class="defaultMessage" role="alert" aria-live="assertive">{{
                  "userRegistration.userInformation.requiredMsg" | cxTranslate
                  }}
                </span>
              </div>

              <!-- <div
            class="
              col-xs-12 col-sm-12 col-md-12
              p0
              Fields-container
              doubleLineContainer
            "
          >
            <label for="userPassword" class="Fields-label"
              >{{
                "userRegistration.userInformation.password.label" | cxTranslate
              }}
            </label>
            <input
              id="userPassword"
              name="password"
              data-valid="valid_facility"
              aria-labelledby="password tooltipFacilityName"
              type="password"
              class="Fields-input"
              autocomplete="off"
              formControlName="password"
              data-di-id="#userPassword"
            />

            <span
              *ngIf="
                !!userInfoForm.get('userInfoDetails.password').value &&
                userInfoForm.get('userInfoDetails.password').valid &&
                !userInfoForm.get('userInfoDetails.password').errors
                  ?.sameAsaccountNo &&
                userInfoForm.get('userInfoDetails').errors
                  ?.userNamePasswordMatch &&
                userInfoForm.get('userInfoDetails.password').touched
              "
              class="errorMessage"
              >{{
                "userRegistration.userInformation.password.usernameAndPasswordNotSame"
                  | cxTranslate
              }}</span
            >

            <span
              *ngIf="
                !!userInfoForm.get('userInfoDetails.password').value &&
                !userInfoForm.get('userInfoDetails.password').valid &&
                userInfoForm.get('userInfoDetails.password').errors
                  ?.sameAsaccountNo &&
                userInfoForm.get('userInfoDetails.password').touched
              "
              class="errorMessage"
              >{{
                "userRegistration.userInformation.password.passwordSameAsAccountNo"
                  | cxTranslate
              }}</span
            >

            <span
              *ngIf="
                !userInfoForm.get('userInfoDetails.password').valid &&
                !userInfoForm.get('userInfoDetails.password').errors
                  ?.required &&
                !userInfoForm.get('userInfoDetails.password').errors
                  ?.sameAsaccountNo &&
                userInfoForm.get('userInfoDetails.password').touched
              "
              class="errorMessage"
              >{{
                "userRegistration.userInformation.password.inValidPassword"
                  | cxTranslate
              }}</span
            >
            <span
              *ngIf="
                userInfoForm.get('userInfoDetails.password').errors?.required &&
                !userInfoForm.get('userInfoDetails.password').valid &&
                userInfoForm.get('userInfoDetails.password').touched
              "
              class="defaultMessage"
              role="alert"
              aria-live="assertive"
              >{{
                "userRegistration.userInformation.requiredMsg" | cxTranslate
              }}
            </span>
          </div>

          <div
            class="
              col-xs-12 col-sm-12 col-md-12
              p0
              Fields-container
              zip-container
            "
          >
            <label for="userConfirmPassword" class="Fields-label">{{
              "userRegistration.userInformation.confirmPassword.label"
                | cxTranslate
            }}</label>
            <input
              id="userConfirmPassword"
              name="confirmPassword"
              data-valid="valid_zip_canada"
              type="password"
              class="Fields-input"
              autocomplete="off"
              formControlName="confirmPassword"
              data-di-id="#userConfirmPassword"
            />

            <span
              *ngIf="
                !userInfoForm.get('userInfoDetails.confirmPassword').valid &&
                !userInfoForm.get('userInfoDetails.confirmPassword').errors
                  ?.required &&
                userInfoForm.get('userInfoDetails.confirmPassword').errors
                  ?.isPasswordInvalid &&
                userInfoForm.get('userInfoDetails.confirmPassword').touched
              "
              class="errorMessage"
              >{{
                "userRegistration.userInformation.password.inValidPassword"
                  | cxTranslate
              }}</span
            >

            <span
              *ngIf="
                !!userInfoForm.get('userInfoDetails.confirmPassword').value &&
                userInfoForm.get('userInfoDetails.confirmPassword').touched &&
                !userInfoForm.get('userInfoDetails.confirmPassword').errors
                  ?.isPasswordInvalid &&
                userInfoForm.get('userInfoDetails').errors?.mismatch
              "
              class="errorMessage"
              >{{
                "userRegistration.userInformation.notMatchMsg" | cxTranslate
              }}</span
            >
            <span
              *ngIf="
                userInfoForm.get('userInfoDetails.confirmPassword').errors
                  ?.required &&
                !userInfoForm.get('userInfoDetails.confirmPassword').valid &&
                userInfoForm.get('userInfoDetails.confirmPassword').touched
              "
              class="defaultMessage"
              role="alert"
              aria-live="assertive"
              >{{
                "userRegistration.userInformation.requiredMsg" | cxTranslate
              }}
            </span>
          </div> -->
            </div>
            <div class="
            col-xs-12 col-sm-12 col-md-12
            p0
            Fields-container
            asses_dropdown
          ">
              <label for="userPasswordRecoverQuestion" id="userPasswordQuestionLabel" class="Fields-label">{{
                "userRegistration.userInformation.passwordRecovery.question.label"
                | cxTranslate
                }}</label>
              <div class="">
                <div class="">
                  <ng-select name="passwordQuestion" [items]="passwordQuestions" [searchable]="false"
                    [clearable]="false" bindLabel="name" bindValue="code" placeholder="Select"
                    formControlName="passwordQuestion" class="dropdown-credit"></ng-select>
                </div>
                <span *ngIf="
                userInfoForm.get('passwordQuestion').errors?.required &&
                !userInfoForm.get('passwordQuestion').valid &&
                userInfoForm.get('passwordQuestion').touched
              " class="errorMessage" role="alert" aria-live="assertive">{{
                  "userRegistration.userInformation.requiredMsg" | cxTranslate
                  }}
                </span>
              </div>
            </div>

            <div class="
            col-xs-12 col-sm-12 col-md-12
            mt-2
            p0
            Fields-container
            zip-container
          ">
              <label for="userPasswordAnswer" class="Fields-label">{{
                "userRegistration.userInformation.passwordRecovery.answer.label"
                | cxTranslate
                }}</label>
              <input id="userPasswordAnswer" name="passwordAnswer" data-valid="valid_zip_canada" type="text"
                class="Fields-input" autocomplete="off" formControlName="passwordAnswer"
                data-di-id="#userPasswordAnswer" />

              <span *ngIf="
              userInfoForm.get('passwordAnswer').errors?.required &&
              !userInfoForm.get('passwordAnswer').valid &&
              userInfoForm.get('passwordAnswer').touched
            " class="defaultMessage" role="alert" aria-live="assertive">{{
                "userRegistration.userInformation.requiredMsg" | cxTranslate }}
              </span>
            </div>
          </div>
        </div>
        <!-- <div
      class="col-xs-12 col-sm-5 col-md-5 p0 password-security focusnone"
      id="passwordDesc"
      tabindex="-1"
    >
      <span class="security-Notify">{{
        "userRegistration.userInformation.password.passwordRuleSection"
          | cxTranslate
      }}</span>
      <ul class="required-ul">
        <li>
          {{
            "userRegistration.userInformation.password.passwordCondition_1"
              | cxTranslate
          }}
        </li>
        <li>
          {{
            "userRegistration.userInformation.password.passwordCondition_2"
              | cxTranslate
          }}
        </li>
        <li>
          {{
            "userRegistration.userInformation.password.passwordCondition_3"
              | cxTranslate
          }}
        </li>
        <li>
          {{
            "userRegistration.userInformation.password.passwordCondition_4"
              | cxTranslate
          }}
        </li>
      </ul>
    </div> -->
        <hr class="Fields-container-line billingPage" />
        <h3 class="pdp-title">
          {{ "userRegistration.userInformation.subTitle" | cxTranslate }}
        </h3>
        <div class="col-xs-12 col-sm-6 col-md-6 p0">
          <div id="registerBilling">
            <div class="
            col-xs-12 col-sm-12 col-md-12
            p0
            Fields-container
            doubleLineContainer
          ">
              <label for="userFirstName" class="Fields-label">{{
                "userRegistration.userInformation.firstName.label" | cxTranslate
                }}
              </label>
              <input id="userFirstName" name="firstName" data-valid="valid_facility" maxlength="40"
                aria-labelledby="firstName tooltipFacilityName" type="text" class="Fields-input" autocomplete="off"
                formControlName="firstName" data-di-id="#userFirstName"  />
              <span *ngIf="
           userInfoForm.get('firstName').value.length != 0 &&
           userInfoForm.get('firstName').invalid &&
           (userInfoForm.get('firstName').touched || userInfoForm.get('firstName').dirty)
         " class="defaultMessage" role="alert">Enter a valid first name</span>

              <span *ngIf="
              userInfoForm.get('firstName').errors?.required &&
              !userInfoForm.get('firstName').valid &&
              userInfoForm.get('firstName').touched
            " class="defaultMessage" role="alert" aria-live="assertive">{{
                "userRegistration.userInformation.requiredMsg" | cxTranslate }}
              </span>
            </div>

            <div class="
            col-xs-12 col-sm-12 col-md-12
            p0
            Fields-container
            doubleLineContainer
          ">
              <label for="userLastName" class="Fields-label">{{
                "userRegistration.userInformation.lastName.label" | cxTranslate
                }}
              </label>
              <input id="userLastName" name="lastName" data-valid="valid_facility" maxlength="40"
                aria-labelledby="lastName tooltipFacilityName" type="text" class="Fields-input" autocomplete="off"
                formControlName="lastName" data-di-id="#userLastName"  />
              <span *ngIf="
            userInfoForm.get('lastName').value.length != 0 &&
            userInfoForm.get('lastName').invalid &&
            (userInfoForm.get('lastName').touched || userInfoForm.get('lastName').dirty)
          " class="defaultMessage" role="alert">Enter a valid last name</span>
              <span *ngIf="
              userInfoForm.get('lastName').errors?.required &&
              !userInfoForm.get('lastName').valid &&
              userInfoForm.get('lastName').touched
            " class="defaultMessage" role="alert" aria-live="assertive">{{
                "userRegistration.userInformation.requiredMsg" | cxTranslate }}
              </span>
            </div>
            <div class="
            col-xs-12 col-sm-12 col-md-8
            p0
            Fields-container
            asses_dropdown
          ">
              <label for="primaryRole" id="roleLabel" class="Fields-label">{{
                "userRegistration.userInformation.role.label" | cxTranslate
                }}</label>
              <div class="">
                <div class="">
                  <ng-select name="role" [items]="contactRole" [searchable]="false" [clearable]="false" bindLabel="name"
                    bindValue="code" placeholder="Select" formControlName="role" class="dropdown-credit"></ng-select>
                </div>
                <span *ngIf="
                userInfoForm.get('role').errors?.required &&
                !userInfoForm.get('role').valid &&
                userInfoForm.get('role').touched
              " class="errorMessage" role="alert" aria-live="assertive">{{
                  "userRegistration.userInformation.requiredMsg" | cxTranslate
                  }}
                </span>
              </div>
            </div>
            <!-- <div formGroupName="emailInfo">
          <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container mt-2">
            <label for="userEmail" class="Fields-label"
              >{{
                "userRegistration.userInformation.email.label" | cxTranslate
              }}
            </label>
            <input
              id="userEmail"
              name="email"
              data-valid="valid_mail"
              type="text"
              class="Fields-input"
              data-view="newemail"
              formControlName="email"
              data-di-id="#userEmail"
            />

            <span
              *ngIf="
                isEmailExists && !userInfoForm.get('emailInfo.email').touched
              "
              class="errorMessage"
            >
              {{
                "userRegistration.userInformation.email.existingEmail"
                  | cxTranslate
              }}</span
            >

            <span
              *ngIf="
                !!userInfoForm.get('emailInfo.email').value &&
                userInfoForm.get('emailInfo.email').invalid &&
                userInfoForm.get('emailInfo.email').touched
              "
              class="defaultMessage"
              role="alert"
              aria-live="assertive"
              >{{
                "userRegistration.userInformation.email.invalidEmail"
                  | cxTranslate
              }}</span
            >
            <span
              *ngIf="
                userInfoForm.get('emailInfo.email').errors?.required &&
                !userInfoForm.get('emailInfo.email').valid &&
                userInfoForm.get('emailInfo.email').touched
              "
              class="defaultMessage"
              role="alert"
              aria-live="assertive"
              >{{
                "userRegistration.userInformation.requiredMsg" | cxTranslate
              }}
            </span>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
            <label for="userConfirmEmail" class="Fields-label"
              >{{
                "userRegistration.userInformation.confirmEmail.label"
                  | cxTranslate
              }}
            </label>
            <input
              id="userConfirmEmail"
              name="confirmEmail"
              data-valid="valid_mail"
              type="text"
              class="Fields-input"
              data-view="confirmemail"
              formControlName="confirmEmail"
              data-di-id="#userConfirmEmail"
            />

            <span
              *ngIf="
                !!userInfoForm.get('emailInfo.confirmEmail').value &&
                userInfoForm.get('emailInfo.confirmEmail').invalid &&
                userInfoForm.get('emailInfo.confirmEmail').touched
              "
              class="defaultMessage"
              role="alert"
              aria-live="assertive"
              >{{
                "userRegistration.userInformation.email.invalidEmail"
                  | cxTranslate
              }}</span
            >

            <span
              *ngIf="
                !!userInfoForm.get('emailInfo.confirmEmail').value &&
                !userInfoForm.get('emailInfo.confirmEmail').invalid &&
                userInfoForm.get('emailInfo').errors?.emailNotMatch
              "
              class="errorMessage"
              >{{
                "userRegistration.userInformation.confirmEmail.emailNotMatch"
                  | cxTranslate
              }}</span
            >
            <span
              *ngIf="
                userInfoForm.get('emailInfo.confirmEmail').errors?.required &&
                !userInfoForm.get('emailInfo.confirmEmail').valid &&
                userInfoForm.get('emailInfo.confirmEmail').touched
              "
              class="defaultMessage"
              role="alert"
              aria-live="assertive"
              >{{
                "userRegistration.userInformation.requiredMsg" | cxTranslate
              }}
            </span>
          </div>
        </div> -->
          </div>
        </div>
        <hr class="Fields-container-line billingPage" />
        <h3 class="pdp-title">
          {{ "userRegistration.userInformation.anotherSubTitle" | cxTranslate }}
        </h3>
        <div>
          <label for="userEmailConsent" id="usrEmailConsentLabel" class="Fields-label-new">{{
            "userRegistration.userInformation.emailConsent.label" | cxTranslate
            }}</label>
          <div class="custom-control custom-control-inline acceptmail-margin-align">
            <input type="radio" id="acceptEmailConsent" name="emailConsent" [value]="isEmailConsent[0]"
              formControlName="emailConsent" class="custom-radio" />
            <label class="custom-control-label" for="acceptEmailConsent">{{
              "userRegistration.userInformation.emailConsent.accepted"
              | cxTranslate
              }}</label>
          </div>
          <div class="custom-control custom-control-inline">
            <input type="radio" id="rejectEmailConsent" name="emailConsent" [value]="isEmailConsent[1]"
              formControlName="emailConsent" class="custom-radio" />
            <label class="custom-control-label" for="rejectEmailConsent">{{
              "userRegistration.userInformation.emailConsent.rejected"
              | cxTranslate
              }}</label>
          </div>
        </div>
        <span class="addAlternateEmail" (click)="addAlternateEmail()"
          *ngIf="!altEmailSection && userInfoForm.get('emailConsent').value">{{
          "userRegistration.userInformation.alternateEmail.title" | cxTranslate
          }}</span>
        <div class="noemailUpdates" style="display: block"
          *ngIf="altEmailSection && userInfoForm.get('emailConsent').value">
          <div formGroupName="alternateEmailInfo">
            <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
              <div class="col-xs-12 col-sm-6 col-md-6 p0 Fields-container">
                <label for="altEmail" class="Fields-label">
                  {{
                  "userRegistration.userInformation.alternateEmail.label"
                  | cxTranslate
                  }}
                </label>
                <input id="altEmail" name="alternateEmail" data-valid="valid_mail" type="text"
                  class="Fields-input field-optional" data-view="altemail" formControlName="alternateEmail"
                  autocomplete="off" data-di-id="#altEmail"  />
                <!-- <a
            (click)="deleteAltEmailSection()"
            title=""
            class="alternate-mail-delete"
            data-di-id="di-id-503c60dc-e8d584e6"
          >
            <img src="../../assets/icons/trash.svg" alt="Delete" />{{
              "userRegistration.userInformation.alternateEmail.delete_alt_section_text"
                | cxTranslate
            }}
          </a> -->
                <span *ngIf="
              (userInfoForm.get('alternateEmailInfo.alternateEmail').errors
                ?.email ||
                userInfoForm.get('alternateEmailInfo.alternateEmail').errors
                  ?.pattern) &&
              !userInfoForm.get('alternateEmailInfo.alternateEmail').valid &&
              userInfoForm.get('alternateEmailInfo.alternateEmail').touched
            " class="defaultMessage" role="alert" aria-live="assertive">{{
                  "userRegistration.userInformation.email.invalidEmail"
                  | cxTranslate
                  }}</span>
                <span *ngIf="
              userInfoForm.get('alternateEmailInfo.alternateEmail').errors
                ?.required &&
              !userInfoForm.get('alternateEmailInfo.alternateEmail').valid &&
              userInfoForm.get('alternateEmailInfo.alternateEmail').touched
            " class="defaultMessage" role="alert" aria-live="assertive">{{
                  "userRegistration.userInformation.requiredMsg" | cxTranslate }}
                </span>
                <label for="confirmAltEmail" class="Fields-label">
                  {{
                  "userRegistration.userInformation.alternateEmail.confirm_alt_email_label"
                  | cxTranslate
                  }}
                </label>
                <input id="confirmAltEmail" name="confirmAlternateEmail" data-valid="valid_mail" type="text"
                  class="Fields-input field-optional" data-view="confirmaltemail"
                  formControlName="confirmAlternateEmail" autocomplete="off" data-di-id="#confirmAltEmail"  />

                <span *ngIf="
              (userInfoForm.get('alternateEmailInfo.confirmAlternateEmail')
                .errors?.email ||
                userInfoForm.get('alternateEmailInfo.confirmAlternateEmail')
                  .errors?.pattern) &&
              !userInfoForm.get('alternateEmailInfo.confirmAlternateEmail')
                .valid &&
              userInfoForm.get('alternateEmailInfo.confirmAlternateEmail')
                .touched
            " class="defaultMessage" role="alert" aria-live="assertive">{{
                  "userRegistration.userInformation.email.invalidEmail"
                  | cxTranslate
                  }}</span>
                <span *ngIf="
              !!userInfoForm.get('alternateEmailInfo.confirmAlternateEmail')
                .value &&
              !userInfoForm.get('alternateEmailInfo.confirmAlternateEmail')
                .invalid &&
              userInfoForm.get('alternateEmailInfo').errors?.altEmailNotMatch
            " class="errorMessage">{{
                  "userRegistration.userInformation.notMatchMsg" | cxTranslate
                  }}</span>
                <span *ngIf="
              userInfoForm.get('alternateEmailInfo.confirmAlternateEmail')
                .errors?.required &&
              !userInfoForm.get('alternateEmailInfo.confirmAlternateEmail')
                .valid &&
              userInfoForm.get('alternateEmailInfo.confirmAlternateEmail')
                .touched
            " class="defaultMessage" role="alert" aria-live="assertive">{{
                  "userRegistration.userInformation.requiredMsg" | cxTranslate }}
                </span>
              </div>
              <div class="col-xs-12 col-sm-4 col-md-4 p0 Fields-container deleteAlign">
                <a (click)="deleteAltEmailSection()" title="" class="alternate-mail-delete"
                  data-di-id="di-id-503c60dc-e8d584e6">
                  <img src="../../assets/icons/{{baseSiteId}}/trash.svg" alt="Delete" />{{
                  "userRegistration.userInformation.alternateEmail.delete_alt_section_text"
                  | cxTranslate
                  }}
                </a>
              </div>
            </div>
          </div>
        </div>
        <hr *ngIf="altEmailSection && userInfoForm.get('emailConsent').value"
          class="Fields-container-line userInfoPage" />
        <!-- <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container captcha-x">
          <re-captcha formControlName="recaptchaReactive" (resolved)="resolved($event)"></re-captcha>
          <span *ngIf="
          userInfoForm.get('recaptchaReactive').errors?.required &&
          !userInfoForm.get('recaptchaReactive').valid &&
          userInfoForm.get('recaptchaReactive').touched
        " class="defaultMessage" role="alert" aria-live="assertive">{{ "userRegistration.userInformation.requiredMsg" |
            cxTranslate }}
          </span>
        </div> -->
        <div class="invoice-btngrps" [ngClass]="
        !!altEmailSection && userInfoForm.get('emailConsent').value
          ? 'alt-section'
          : ''
      ">
      <!-- [disabled]=" userInfoForm.get('recaptchaReactive').errors?.required" -->
          <button type="submit" class="btn-primary" data-di-id="di-id-7a6cb2cd-cb37948a">
            {{ "userRegistration.userInformation.submit_button" | cxTranslate }}
          </button>
          <!-- <button type="submit" class="btn-primary" data-di-id="di-id-7a6cb2cd-cb37948a">
            {{ "userRegistration.userInformation.submit_button" | cxTranslate }}
          </button> -->
        </div>
      </form>
    </div>
  </div>
  <div class="col-xs-12 col-sm-12 col-md-4 needCls needCls2" [innerHTML]="(finalNeedAss | async)?.content">
  </div>
</div>